function formatChallengeDate(value: string): string {
  const parsed = new Date(`${value}T12:00:00`);
  if (Number.isNaN(parsed.getTime())) return value;
  return new Intl.DateTimeFormat('en-GB', { day: 'numeric', month: 'short' }).format(parsed);
}

export function formatFamilyChallengeDateRange(startsOn: string, endsOn: string): string {
  return `${formatChallengeDate(startsOn)} to ${formatChallengeDate(endsOn)}`;
}
